import React from 'react';
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useCommonHandlers } from './Handlers';
import { PortalPageHeader } from './layout/PortalPageHeader';
import { isPortalTopLevelPath } from './layout/portalNavPaths';
import { usePortalTokens } from '../styles/usePortalTokens';

const PageContainer = ({ children, title, contentSx, hideHeader = false }) => {
  const location = useLocation();
  const { handleBack } = useCommonHandlers();
  const portal = usePortalTokens();

  const showBackButton = !hideHeader && !isPortalTopLevelPath(location.pathname);
  const showTitle = !hideHeader && Boolean(title);

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
      {showTitle || showBackButton ? (
        <PortalPageHeader title={title} onBack={handleBack} showBack={showBackButton} />
      ) : null}
      <Box
        sx={{
          backgroundColor: portal.surface,
          padding: { xs: 2.5, md: '28px 32px 40px' },
          borderRadius: '16px',
          boxShadow: portal.cardShadow,
          flexGrow: 1,
          minHeight: 0,
          overflow: 'auto',
          ...contentSx,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default PageContainer;
